module.exports = __webpack_public_path__ + "img/andalucia-logo-big.f2a139dd.png";